import { render, staticRenderFns } from "./gshow.vue?vue&type=template&id=5c1479c2&scoped=true&"
import script from "./gshow.vue?vue&type=script&lang=js&"
export * from "./gshow.vue?vue&type=script&lang=js&"
import style0 from "./gshow.vue?vue&type=style&index=0&id=5c1479c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1479c2",
  null
  
)

export default component.exports